import { buildDate } from './build-date';

const isForceStringField = (columnId) => [
    'account',
    'accountNumber',
    'currentDealer',
    'currentDealerId',
    'dealer',
    'dealerAccount',
    'dealerInvoiceNumber',
    'invoiceDealer',
    'invoiceRequest',
    'leadAccount',
    'legacyCustomer',
    'newDealer',
    'responsibleDealer',
].some((field) => field === columnId);

const isDateField = (columnId) => [
    'actualAuditDate',
    'approvalDate',
    'basicWarrantyEndDate',
    'basicWarrantyStartDate',
    'beginDate',
    'contractPurchaseDate',
    'completionDate',
    'changedOn',
    'createdDate',
    'creationDate',
    'creditMemoDate',
    'dateIssued',
    'deliveryDate',
    'decisionDate',
    'effectiveDate',
    'endDate',
    'estimatedBasicDate',
    'expectedDateOfFirstUse',
    'expirationDate',
    'expireDate',
    'failureDate',
    'intervalBeginDate',
    'intervalEndDate',
    'invoiceDate',
    'originalSubmissionDate',
    'planEndDate',
    'planStartDate',
    'registrationDate',
    'repairDate',
    'reportDate',
    'requestDate',
    'settlementDate',
    'startDate',
    'submissionDate',
    'terminationDate',
    'updatedDate',
].some((dateField) => dateField === columnId);

export const getFormattedCellValues = (params) => {

    let returnString;

    const columnId = params.column.colId;

    if (isForceStringField(columnId)) {

        returnString = `${params.value}${String.fromCharCode(9)}`;

    } else if (isDateField(columnId)) {

        returnString = buildDate(params.value);

    } else {

        returnString = params.value;

    }

    return returnString;

};
